import './App.css';
import AppThenme from './componets/Theme/theme';

function App() {
  return (
    <AppThenme/>
  );
}

export default App;
